import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 15px 20px;

  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 300px;
  max-height: 80dvh;

  margin-top: 15px;
  padding: 12px;
  border: 1px solid ${({ theme }) => theme['warmgray-300']};
  border-radius: 6px;

  color: ${({ theme }) => theme['font-secondary']};
  text-overflow: ellipsis;

  font-family: 'Pretendard';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
  letter-spacing: 0.5px;

  &::placeholder {
    color: ${({ theme }) => theme['font-tertiary']};
    text-overflow: ellipsis;
    white-space: nowrap;

    font-family: 'Pretendard';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
    letter-spacing: 0.5px;
  }

  resize: none;
`;

export const TextCountParagraph = styled.p`
  text-align: right;
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  color: ${({ theme }) => theme.gray02};
`;

export const BottomSubmitButtonWrapper = styled.div`
  width: 100%;
  padding: 15px 24px;

  background-color: ${({ theme }) => theme['white-primary']};
`;
